<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>ข้อมูลลูกค้าร้านค้า</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="text-center" v-if="isShowButtonLookup">
                <button class="btn btn-red" @click="openLookupCustomerStore()">ค้นหาลูกค้าร้านค้า</button>
            </div>

            <div class="form" v-if="isShowCustomerInfo">
                <div class="dashed-line mt-3 mb-3" v-if="isShowButtonLookup"></div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เลขประจำตัวผู้เสียภาษี</label>
                            <input type="tel" 
                                v-model="formData.customerStore.taxId"
                                class="input-field"
                                :class="{ 'invalid': errorData.customerStore.taxId.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="20"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="เลขประจำตัวผู้เสียภาษี" />
                            <div class="input-error-message" v-if="errorData.customerStore.taxId.blank">โปรดกรอกเลขประจำตัวผู้เสียภาษี</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ชื่อร้านค้า</label>
                            <input type="text" 
                                v-model="formData.customerStore.name"
                                class="input-field"
                                :class="{ 'invalid': errorData.customerStore.name.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="100"
                                placeholder="ชื่อร้านค้า" />
                            <div class="input-error-message" v-if="errorData.customerStore.name.blank">โปรดกรอกชื่อร้านค้า</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ชื่อผู้ติดต่อ</label>
                            <input type="text" 
                                v-model="formData.customerStore.contactPerson"
                                class="input-field"
                                :class="{ 'invalid': errorData.customerStore.contactPerson.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="100"
                                placeholder="ชื่อผู้ติดต่อ" />
                            <div class="input-error-message" v-if="errorData.customerStore.contactPerson.blank">โปรดกรอกชื่อผู้ติดต่อ</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เบอร์ติดต่อร้านค้า</label>
                            <input type="tel"
                                v-model="formData.customerStore.contactTel"
                                class="input-field"
                                :class="{ 'invalid': errorData.customerStore.contactTel.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="20"
                                @keypress="$AppUtility.inputOnlyNumber($event)"
                                placeholder="เบอร์ติดต่อร้านค้า" />
                            <div class="input-error-message" v-if="errorData.customerStore.contactTel.blank">โปรดกรอกเบอร์ติดต่อร้านค้า</div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>ที่อยู่เลขที่/ซอย/ถนน</label>
                            <input type="text"
                                v-model="formData.customerStore.address"
                                class="input-field"
                                :class="{ 'invalid': errorData.customerStore.address.blank }"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                maxlength="100"
                                placeholder="ที่อยู่ร้านค้า" />
                            <div class="input-error-message" v-if="errorData.customerStore.address.blank">โปรดกรอกเบอร์ที่อยู่เลขที่</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>แขวง/ตำบล</label>
                            <typeahead
                                ref="thaiAddressDataTumbon"
                                placeholder="แขวง/ตำบล"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.customerStore.subDistrict"
                                :inputClass="['input-field', (errorData.customerStore.subDistrict.blank ? 'invalid' : '')]"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'tumbon')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'tumbon')" />
                            <div class="input-error-message" v-if="errorData.customerStore.subDistrict.blank">โปรดกรอกแขวง/ตำบล</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>เขต/อำเภอ</label>
                            <typeahead
                                ref="thaiAddressDataAmphur"
                                placeholder="เขต/อำเภอ"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.customerStore.district"
                                :inputClass="['input-field', (errorData.customerStore.district.blank ? 'invalid' : '')]"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'amphur')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'amphur')" />
                            <div class="input-error-message" v-if="errorData.customerStore.district.blank">โปรดกรอกเขต/อำเภอ</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>จังหวัด</label>
                            <typeahead
                                ref="thaiAddressDataProvince"
                                placeholder="จังหวัด"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.customerStore.province"
                                :inputClass="['input-field', (errorData.customerStore.province.blank ? 'invalid' : '')]"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'province')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'province')" />
                            <div class="input-error-message" v-if="errorData.customerStore.province.blank">โปรดกรอกจังหวัด</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>รหัสไปรษณีย์</label>
                            <typeahead
                                ref="thaiAddressDataPostCode"
                                placeholder="รหัสไปรษณีย์"
                                :listData="mixinsThaiAddress_List"
                                v-model="formData.customerStore.postCode"
                                :inputClass="['input-field', (errorData.customerStore.postCode.blank ? 'invalid' : '')]"
                                :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                @hit="mixinsThaiAddress_SetThaiAddressValue($event)"
                                @input="mixinsThaiAddress_SetAutoComplete($event, 'postcode')"
                                @blur="mixinsThaiAddress_CheckValidInputAddress($event, 'postcode')" />
                            <div class="input-error-message" v-if="errorData.customerStore.postCode.blank">โปรดกรอกรหัสไปรษณีย์</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-store-lookup :isDisplay="isShowLookupCustomerStore" @hide="closeLookupCustomerStore($event)"></job-modal-store-lookup>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import ThaiAddress from '@/resources/mixins/ThaiAddress';
import JobModalStoreLookup from '@/components/job/order/ModalStoreLookup';

export default {
    mixins: [ MixinThemeBoard, ThaiAddress ],
    components: {
        JobModalStoreLookup
    },
    data() {
        return {
            isShowButtonLookup: true,
            isShowLookupCustomerStore: false,
            isShowCustomerInfo: false,
            formData: null
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);

            if (this.loadData) {
                if (this.loadData.status !== this.$Constants.JOB_STATUS_NEW) {
                    this.initPendingDisplay();
                }
            }
        },
        initPendingDisplay() {
            this.isShowButtonLookup = false;
            this.isShowCustomerInfo = true;
        },
        initForm() {
            return {
                customerStore: {
                    taxId: this.loadData ? this.loadData.customerStore.taxId : '',
                    name: this.loadData ? this.loadData.customerStore.name : '',
                    contactPerson: this.loadData ? this.loadData.customerStore.contactPerson : '',
                    contactTel: this.loadData ? this.loadData.customerStore.contactTel : '',
                    address: this.loadData ? this.loadData.customerStore.address : '',
                    subDistrict: this.loadData ? this.loadData.customerStore.subDistrict : '',
                    district: this.loadData ? this.loadData.customerStore.district : '',
                    province: this.loadData ? this.loadData.customerStore.province : '',
                    postCode: this.loadData ? this.loadData.customerStore.postCode : ''
                }
            };
        },
        openLookupCustomerStore() {
            this.isShowLookupCustomerStore = true;
        },
        closeLookupCustomerStore(data) {
            this.isShowLookupCustomerStore = false;
            this.isShowCustomerInfo = true;

            if (data) {
                this.mapLookupData(data);
            }
            
            this.$emit('customerReady');
        },
        mapLookupData(data) {
            this.formData.customerStore.taxId = data.taxId;
            this.formData.customerStore.name = data.name;
            this.formData.customerStore.contactPerson = data.contactPerson;
            this.formData.customerStore.contactTel = data.contactTel;
            this.formData.customerStore.address = data.address;
            this.formData.customerStore.subDistrict = data.subDistrict;
            this.formData.customerStore.district = data.district;
            this.formData.customerStore.province = data.province;
            this.formData.customerStore.postCode = data.postCode;
        }
    }
}
</script>